import React from 'react';

import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import './SaveSelectionHeader.scss';

const propTypes = {
  onUploadFiles: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function SaveSelectionHeader({ onUploadFiles }) {
  return (
    <div>
      <span className="header-title">Edit Images</span>

      <Button onClick={onUploadFiles} content="Add More Images" className="action-button" />
    </div>
  );
}

SaveSelectionHeader.propTypes = propTypes;
SaveSelectionHeader.defaultProps = defaultProps;
